import React, {useState} from 'react';
import '../HomePage/Styles.css';
import { Link } from 'react-router-dom';  // Import Link from react-router-dom
import useTitle from '../../useTitle';
import ContactSection from '../ContactSection/Index';
import TestimonialSection from '../ReviewsKlantenPage/Index';

const HomePagina = () => {
    useTitle("Vind je balans, kracht en vrede!");
    // eslint-disable-next-line no-unused-vars
    const [isOpen, setIsOpen] = useState(false);
    // Close the navbar when a link is clicked
    const handleLinkClick = (url) => {
        setIsOpen(false); // Close the navbar
        window.location.href = url; // Force navigation to the specific URL
    };

  return (
    <>  
        {/* Home Section */}
        <div className='homeSection'>
            <img 
                className='headerImageMindfulBreaks'
                src='/images/Agija-38.jpg'
                alt='header mindful breaks'
                width="1920"
                height="1080"
                loading="eager"
                fetchPriority="high"
            />
            <div className='homeSectionOne'>
                <div className='homeTitleSection'>
                    <h2 className='subTitle'>Mindful <b>Breaks</b> Yoga</h2>
                    <h1 className='homeTitle'>Vind je balans, kracht en vrede</h1>
                </div>
                <div className='homeDescriptionSection'>
                    <p className='homeDescriptionText'>Tussen volle agenda's en hoge verwachtingen is dit jouw moment om even tot rust te komen. Een moment waar je weer mag voelen, ademen en bewegen. Hier draait alles om jou, op maat in alle rust en met volledige aandacht.</p>
                </div>
                <div className='homeButtonSection'>
                    <Link onClick={() => handleLinkClick('/contact')}>
                        <button className='homeButtonContact'>Neem contact op</button>
                    </Link>
                </div>
            </div>
        </div>

        {/* About Us Section */}
        <div className='aboutSection' id='overOns'>
            <div className='aboutSectionOne'>
                <div className='aboutTitle'>
                    <h1>Welkom bij Mindful Breaks</h1>
                </div>
                <div className='aboutDescription'>
                    <p>Heb je last van stress, spanning in je lichaam of het gevoel dat je altijd "aan" staat? Bij Mindful Breaks help ik je om terug rust en balans te vinden via persoonlijke yogalessen en gerichte ademhalingstechnieken.</p>
                    <br />
                    <p>Of je nu begint met yoga of al ervaring hebt, de sessies worden volledig afgestemd op jouw noden. Denk aan het verminderen van stress, het verlichten van fysieke klachten of simpelweg meer ontspanning vinden in je dagelijks leven.</p>
                    <br />
                    <p>Ook bedrijven ondersteun ik in het versterken van het welzijn op de werkvloer. Met toegankelijke yoga sessies help ik medewerkers om stress te verlagen, beter te focussen en zich zowel mentaal als fysiek sterker te voelen.</p>
                    <br />
                    <p>Yoga hoeft niet ingewikkeld te zijn. Het gaat om kleine, haalbare momenten van rust die een groot verschil maken zowel thuis als op het werk.</p>
                </div>
            </div>
            <div className='aboutSectionTwo'>
                <img src='/images/Agija-32-600.jpg' className='imageAbout' alt='yoga mindful breaks' srcSet="
                    /images/Agija-32-360.jpg 360w,
                    /images/Agija-32-600.jpg 600w,
                    /images/Agija-32-1200.jpg 1200w
                "
                sizes="(max-width: 768px) 360px, 600px" />
            </div>
        </div>

        {/* Ons Aanbod Section */}
        <div className='whatWeDoSection' id='onsAanbod'>
            <h1 className='aanbodTitle'>Aanbod</h1>
            <div className='whatWeDoOverView'>
                <div className='whatWeDoPartOne'>
                    <img src='/images/Agija-11-320.jpg' alt='privelessen icon' className='iconsWhatWeDo'
                        srcSet="
                            /images/Agija-11-320.jpg 320w,
                            /images/Agija-11-640.jpg 640w,
                            /images/Agija-11-960.jpg 960w
                        "
                        sizes="320px"
                        />
                    <h2>Privélessen</h2>
                    <p>Persoonlijke yogalessen bij jou thuis, volledig afgestemd op jouw lichaam en noden. Geen verplaatsing, geen groepsles gewoon rust, aandacht en begeleiding op maat. Ideaal bij stress, spanning, fysieke klachten of gewoon om meer balans en energie te vinden in je dagelijks leven.</p>
                    <Link onClick={() => handleLinkClick('/privelessen')} className='ontdekMeerButton'>Ontdek privé yoga</Link>
                </div>
                <div className='whatWeDoPartOne'>
                    <img src='/images/Agija-21-320.jpg' alt='yoga@work icon' className='iconsWhatWeDo'  srcSet="
                            /images/Agija-21-320.jpg 320w,
                            /images/Agija-21-640.jpg 640w,
                            /images/Agija-21-960.jpg 960w
                        "
                        sizes="320px"
                        />
                    <h2>Yoga voor bedrijven</h2>
                    <p>Wil je stress bij je team verminderen en tegelijkertijd focus, energie en welzijn verhogen? Met yoga op de werkvloer bied je medewerkers een toegankelijke en praktische manier om te ontspannen en beter om te gaan met werkdruk gewoon op kantoor, tijdens de werkdag.</p>
                    <Link onClick={() => handleLinkClick('/yogavoorbedrijven')}  className='ontdekMeerButton'>Ontdek yoga op de werkvloer</Link>
                </div>
            </div>
        </div>

        {/* Testimonial Section */}
        <TestimonialSection />

        {/* Contact/Menu Section */}
        <ContactSection />
    </>
  )
}

export default HomePagina;